<template>
    <div>
        <my-form 
            style="width:301px;"
            v-model="form"
            label-width="80px"
            @cancle="closeHandler"
            @submit="submitHandler"
            >
                <el-form-item
                class="table-full-row"
                prop="timing"
                label="提醒时间"
                :rules="newRule('提醒时间', 'required')"
                >
                    <el-date-picker
                        v-model="form.timing"
                        type="datetime"
                        placeholder="选择提醒时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item
                class="table-full-row"
                prop="title"
                label="提醒标题"
                :rules="newRule('提醒标题', 'required', 'min2', 'max20')"
                >
                    <el-input
                        v-model="form.title"
                        placeholder="输入简明扼要的提醒标题"
                    ></el-input>
                </el-form-item>

                <el-form-item
                class="table-full-row"
                prop="content"
                label="提醒内容"
                :rules="newRule('提醒内容', 'max50')"
                >
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        placeholder="请输入内容"
                        v-model="form.content"
                    ></el-input>
                </el-form-item>

                
            </my-form>
    
            <el-dialog
                title="提示"
                center
                :append-to-body="true"
                :visible.sync="dialogVisible"
                width="600px">
                    <div class="wxTxinfo">
                        <p>
                            <i class="el-icon-warning" style="color:#E6A23C;"></i>
                            该账号未绑定微信，请扫码关注惠招标微信公众号，左下角惠工作-平台登录，成功登录即微信绑定成功
                        </p>
                        <p>
                            <img style="display: block; width: 172px; margin: 0 auto;" :src="imgsrc">
                        </p>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
                    </span>
            </el-dialog>
    </div>
    
</template>


<script>
export default {
    data() {
        return {
            form: {
                title: '',
                timing: '',
                content: '',
            },

            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < (Date.now() - (24 * 60 * 60 * 1000));
                },
            },
            dialogVisible:false,
            imgsrc:`${window._config.rely}/weixin.jpg`
        };
    },
    methods: {
        closeHandler() {
            this.form = {
                title: '',
                timing: '',
                content: '',
            };

            this.$emit('close');
        },
        submitHandler() {
            this.$post(`${this.getGetters('mngUrl')}/v2/notice/add.json`, this.form, (data, res) => {
                if (data && data.notfollow) {
                    // this.$emit('notfollow');
                    this.dialogVisible = true
                    return;
                }

                this.$emit('add');
                this.closeHandler();
            });
        },
    }
};
</script>

<style>
    .wxTxinfo p{ text-align: center; }
</style>